import clsx from 'clsx';
import { Author } from './blog-post-intro.types';
import { WrappedImage } from '../image-component/wrapped-image';
import { Text } from '../../ui-components/text/text';
import dayjs from 'dayjs';
import { ColorName } from '../../style/color-classes';

interface Props {
    author: Author;
    date: string;
    postType: string;
    isMobile: () => boolean;
}
export const BlogPostAuthor = (props: Props) => {
    return (
        <div
            class={clsx(
                'flex',
                { 'flex-row': props.postType === 'corporate' },
                { 'flex-col': props.postType === 'personal' },
                'tablet:flex-row',
                'items-center',
                'tablet:items-center',
                'mt-s',
                'w-full',
                'tablet:w-auto',
            )}
        >
            <div class={clsx('h-24 w-24 items-center rounded-full mr-4')}>
                {props?.author?.profilePicture && (
                    <WrappedImage
                        image={props.author.profilePicture}
                        aspectRatio="square"
                        renderWidth="100%"
                        renderHeight="auto"
                        roundCorners="full"
                        width="100px"
                        height="auto"
                    />
                )}
            </div>
            <div class={clsx('flex flex-col justify-center text-center', { 'm-auto': props.postType === 'personal' })}>
                <Text align={props.isMobile() && props.postType === 'personal' ? 'center' : 'left'} fontSize="l" tag="span" disableMargins={true}>
                    {props?.author?.visibleName}
                </Text>
                <Text
                    align={props.isMobile() && props.postType === 'personal' ? 'center' : 'left'}
                    fontSize="s"
                    tag="span"
                    color={ColorName.Neutral600}
                    disableMargins={true}
                >
                    {props?.author?.visibleTitle}
                </Text>
                {props.date && (
                    <Text
                        align={props.isMobile() && props.postType === 'personal' ? 'center' : 'left'}
                        fontSize="s"
                        tag="span"
                        color={ColorName.Neutral600}
                        disableMargins={true}
                    >
                        {dayjs(new Date(props.date)).format('D MMM, YYYY')}
                    </Text>
                )}
            </div>
        </div>
    );
};
